import React from 'react'

const IconSvg = () => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M24.9998 4.16602C13.4998 4.16602 4.1665 13.4993 4.1665 24.9994C4.1665 36.4994 13.4998 45.8327 24.9998 45.8327C36.4998 45.8327 45.8332 36.4994 45.8332 24.9994C45.8332 13.4993 36.4998 4.16602 24.9998 4.16602ZM20.8332 35.416L10.4165 24.9994L13.354 22.0619L20.8332 29.5202L36.6457 13.7077L39.5832 16.666L20.8332 35.416Z'
      fill='#040603'
      fillOpacity='0.25'
    />
  </svg>
)

export default IconSvg
